<template>
  <div class="dashboard-container">
    <div class="app-container">目录管理</div>
  </div>
</template>

<script>
export default {
  name: 'DirectorysList',
  data() {
    return {}
  }
}
</script>

<style scoped>
</style>
